import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=10a4ad0e&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=10a4ad0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4ad0e",
  null
  
)

export default component.exports